import request from "@/utils/request";
// import { objectToQuerystring } from "@/utils/filters";

export function indexUsers(query) {
  return request({
    url: `api/admin/users?page=${query}`,
    method: "get"
  });
}
export function getAdmins() {
  return request({
    url: `api/admin/users`,
    method: "get"
  });
}

export function createUser(data) {
  return request({
    url: "api/admin/users",
    method: "post",
    data
  });
}

export function updateUser(data, username) {
  return request({
    url: `api/admin/users/${username}`,
    method: "put",
    data
  });
}

export function deleteUser({ id }) {
  return request({
    url: `api/admin/users/${id}`,
    method: "delete"
  });
}
export function deleteUserImg(username) {
  return request({
    url: `api/admin/users/${username}/photo`,
    method: "delete"
  });
}

export function blockUser({ id }, data) {
  data._method = "put";

  return request({
    url: `api/admin/toggle/user/${id}/blocked`,
    method: "post",
    data
  });
}

export function showUser({ username }) {
  return request({
    url: `api/admin/users/${username}`,
    method: "get"
  });
}

export function showUserAddress({ username }) {
  return request({
    url: `api/admin/users/${username}/addresses`,
    method: "get"
  });
}

export function indexUsersByPage(queries) {
  return request({
    url: `/api/admin/users?page=${queries}`,
    method: "get",
    name: "indexUser"
  });
}
